import React, { useState, useCallback, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { styled } from "@mui/system";
import { ReactComponent as Contatti } from "../../assets/Acquisti/Contatti.svg";
import { ReactComponent as Qualificazione } from "../../assets/Acquisti/Qualificazione.svg";
import { ReactComponent as Documenti } from "../../assets/Acquisti/Documenti.svg";
import { ReactComponent as Agenda } from "../../assets/Acquisti/Agenda.svg";
import { useLocation, useNavigate } from "react-router-dom";
import "./MenuLink.scss";
import { useDispatch } from "react-redux";
// const dispatch = useDispatch(); // Make sure this is at the top of your component

const CustomTabs = styled(Tabs)({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    display: "none",
  },
});

const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: 700,
    minWidth: 100,
    padding: "10px 15px",
    flexDirection: "row",
    fontSize: "14px",
    lineHeight: "16px",
    borderRadius: "20px",
    transition: "background-color 0.3s, color 0.3s",
    color: "#fff", // White text for all tabs
    "&.Mui-selected": {
      backgroundColor: "#185ABD", // Blue background for selected tab
    },
    "&:not(.Mui-selected)": {
      backgroundColor: "#F5F5F5", // Gray background for unselected tabs
      color: "#185ABD", // Blue text for unselected tabs
    },
  })
);



export const TAB_CONFIGURATIONS = {
  subStabilimenti: [
    { label: "Gaicenze", icon: Contatti },
    { label: "Mezzi", icon: Qualificazione },
    { label: "Attrezzature", icon: Agenda },
    { label: "Collaboratori", icon: Documenti },
    { label: "Contatti", icon: Documenti },
  ],
  subCantine: [
    { label: "Terreni", icon: Contatti },
    { label: "Stabilimenti", icon: Contatti },
    { label: "Prodotti", icon: Contatti },
    { label: "Mezzi", icon: Contatti },
  ],
  subTerreni: [
    { label: "Particelle", icon: Contatti },
    { label: "Sensori", icon: Contatti },
    { label: "Trattamenti", icon: Contatti },
  ],
  subStructureStabiliment: [
    { label: "Attrezzature", icon: Contatti },
    { label: "Sensori", icon: Contatti },
    { label: "Giacenze", icon: Contatti },
  ],
  subStructureProdotti: [

    { label: "Giacenze", icon: Contatti },
  ],
  ricette: [

    { label: "Fasi", icon: Contatti },
    { label: "Dati ", icon: Contatti },
    { label: "Statistiche", icon: Contatti },
  ],
  subMezziLogistica: [

    { label: "Manutenzione", icon: Contatti },
    { label: "Documenti", icon: Contatti },
    { label: "Sensori", icon: Contatti },
    { label: "Viaggi", icon: Contatti },
  ],
  subStabilimentiLogistica: [
    { label: "Attrezzature", icon: Contatti },
    { label: "Sensori", icon: Contatti },
    { label: "Giacenze", icon: Contatti },
  ],
  subSensori:[
    { label: "Oggi", icon: Contatti },
    { label: "ultima_settimana", icon: Contatti },
    { label: "ultimo_mese", icon: Contatti },
    { label: "Archivio", icon: Contatti },
  ]
};


const getNavigationPath = (label, isLead, isFornitori, isaminiImposte, isImposte, isAsset, isServizi, isProdotti, isConfiguratore, isListini, isHrCandidato, isHrBusta, isHr, ishrCalendario, isStabilimenti, isMezzi, isAttrezzature, isleadAnagrafiche, isAnagraficheCandidato, isColaboratoryAnagrafiche, isFornitoriAnagrafiche, isClientiAnagrafiche, isorganizza, isorganizzaCalender, subProgetti, subCantine, subTerreni, subStructureProdotti, subStructureStabiliment, ricette, subMezziLogistica, subStabilimentiLogistica,subSensori) => {
// 👇 Inside your MenuTab component

  // console.log(isorganizzaCalender, "isorganizzaCalender")
  if (isLead) return `/vendite/sub-lead/${label}`;

  if (isFornitori) return `/acquisti/fornitori/${label}`;

  if (isImposte) return `/amministrazione/imposte/${label}`;

  if (isAsset) return `/amministrazione/asset/${label}`;

  if (isServizi) return `/cataloghi/servizi/${label}`;

  if (isProdotti) return `/cataloghi/prodotti/${label}`;

  if (isConfiguratore) return `/cataloghi/configuratore/${label}`;

  if (isListini) return `/cataloghi/listini/${label}`;

  if (isHrCandidato) return `/hr/candidati/candidato/${label}`;

  if (isHrBusta) return `/hr/buste-page/${label}`;

  if (isHr) return `/hr/sub-colaboratory/${label}`;

  if (ishrCalendario) return `/hr/${label}`;

  if (isStabilimenti) return `/logistica/stabilimenti1/${label}`;

  if (isMezzi) return `/logistica/mezzi/${label}`;

  if (isAttrezzature) return `/logistica/attrezzature/${label}`;


  if (isleadAnagrafiche) return `/anagrafiche/sub-lead/${label}`;
  if (isAnagraficheCandidato)
    return `/angrafiche/candidati/${label}`;
  if (isColaboratoryAnagrafiche)
    return `/angrafiche/sub-colaboratory/${label}`;
  if (isFornitoriAnagrafiche)
    return `/angrafiche/fornitori/${label}`;
  if (isClientiAnagrafiche)
    return `/angrafiche/clienti/${label}`;
  if (isorganizza) return `/attivita/${label}`;
  if (isorganizzaCalender) return `/hr/organizza/calender`;
  if (subProgetti) return `/attivita/progetti/${label}`;
  // newchanges
  if (subCantine) return `/strutture/cantine/${label}`;
  if (subTerreni) return `/strutture/terreni/${label}`;
  if (subStructureProdotti) return `/strutture/prodotti/${label}`;
  if (subStructureStabiliment) return `/strutture/stabiliment/${label}`;
  if (ricette) return `/produzione/ricette/${label}`;
  if (subMezziLogistica) return `/logistica/mezzi/${label}`;
  if (subStabilimentiLogistica) return `/logistica/stabilimenti/${label}`;
  if (subSensori){
    
    // dispatch(fetchWeatherData());
      return `/strutture/sensori/Location/${label}`;
    }

   

  return `/dashboard/${label}`;

};

const MenuTab = ({
  onTabChange,
  customClassName = "customTab",
  dashboardForm = false,
  statsDashboard = false,
  dettaglioForm = false,
  lead = false,
  fornitori = false,
  vendite = false,
  gantt = false,
  subSensori=false,
  subImposte = false,
  subAsset = false,
  subServizi = false,
  subProdotti = false,
  configuratore = false,
  sublistini = false,
  hrCandidato = false,
  hrEvento = false,
  hr = false,
  hrcalendario = false,
  subStabilimenti = false,
  subMezzi = false,
  subAttrezzature = false,
  leadAnagrafiche = false,
  anagraficheCandidato = false,
  colaboratoryAnagrafiche = false,
  fornitoriAnagrafiche = false,
  clientiAnagrafiche = false,
  organizza = false,
  organizzaCalender = false,
  subProgetti = false,
  // newchanges
  subCantine = false,
  subTerreni = false,
  subStructureStabiliment = false,
  subStructureProdotti = false,
  ricette = false,
  subMezziLogistica = false,
  subStabilimentiLogistica = false
}) => {
  const [selectedTabs, setSelectedTabs] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Determine which configuration to use based on props
  const getActiveConfig = useCallback(() => {
    if (gantt) return TAB_CONFIGURATIONS.gantt;
    if (dashboardForm) return TAB_CONFIGURATIONS.dashboardForm;
    if (statsDashboard) return TAB_CONFIGURATIONS.statsDashboard;
    if (dettaglioForm) return TAB_CONFIGURATIONS.dettaglioForm;
    if (lead) return TAB_CONFIGURATIONS.lead;
    if (subImposte) return TAB_CONFIGURATIONS.subImposte;
    if (subAsset) return TAB_CONFIGURATIONS.subAsset;
    if (subServizi) return TAB_CONFIGURATIONS.subServizi;
    if (subProdotti) return TAB_CONFIGURATIONS.subProdotti;
    if (configuratore) return TAB_CONFIGURATIONS.configuratore;
    if (sublistini) return TAB_CONFIGURATIONS.sublistini;
    if (hrCandidato) return TAB_CONFIGURATIONS.hrCandidato;
    if (hrEvento) return TAB_CONFIGURATIONS.hrEvento;
    if (hr) return TAB_CONFIGURATIONS.hr;
    if (hrcalendario) return TAB_CONFIGURATIONS.hrcalendario;
    if (subStabilimenti) return TAB_CONFIGURATIONS.subStabilimenti;
    if (subMezzi) return TAB_CONFIGURATIONS.subMezzi;
    if (subAttrezzature) return TAB_CONFIGURATIONS.subAttrezzature;
    if (leadAnagrafiche) return TAB_CONFIGURATIONS.leadAnagrafiche;
    if (anagraficheCandidato) return TAB_CONFIGURATIONS.anagraficheCandidato;
    if (colaboratoryAnagrafiche) return TAB_CONFIGURATIONS.colaboratoryAnagrafiche;
    if (fornitoriAnagrafiche) return TAB_CONFIGURATIONS.fornitoriAnagrafiche;
    if (clientiAnagrafiche) return TAB_CONFIGURATIONS.clientiAnagrafiche;
    if (organizza) return TAB_CONFIGURATIONS.organizza;
    if (organizzaCalender) return TAB_CONFIGURATIONS.organizzaCalender;
    if (subProgetti) return TAB_CONFIGURATIONS.subProgetti;
    // newchanges
    if (subCantine) return TAB_CONFIGURATIONS.subCantine;
    if (subTerreni) return TAB_CONFIGURATIONS.subTerreni;
    if (subStructureProdotti) return TAB_CONFIGURATIONS.subStructureProdotti;
    if (subStructureStabiliment) return TAB_CONFIGURATIONS.subStructureStabiliment;
    if (ricette) return TAB_CONFIGURATIONS.ricette;
    if (subMezziLogistica) return TAB_CONFIGURATIONS.subMezziLogistica;
    if (subStabilimentiLogistica) return TAB_CONFIGURATIONS.subStabilimentiLogistica;
    if (subSensori) return TAB_CONFIGURATIONS.subSensori;
    console.log(TAB_CONFIGURATIONS.subSensori);
    
    return TAB_CONFIGURATIONS.default;
  }, [gantt, dashboardForm, statsDashboard, dettaglioForm, lead, subImposte, subAsset, subServizi, subProdotti, configuratore, sublistini, hrCandidato, hrEvento, hr, hrcalendario, subStabilimenti, subMezzi, subAttrezzature, leadAnagrafiche, anagraficheCandidato, colaboratoryAnagrafiche, fornitoriAnagrafiche, clientiAnagrafiche, organizza, organizzaCalender, subProgetti, subCantine, subTerreni, subStructureProdotti, subStructureStabiliment, ricette, subMezziLogistica, subStabilimentiLogistica,subSensori]);

  const tabsConfig = getActiveConfig();

  // Sync selectedTabs with the current route
  useEffect(() => {
    const activeIndex = tabsConfig?.findIndex((tab) =>
      location.pathname.toLowerCase().includes(tab.label.toLowerCase())
    );
    if (activeIndex !== -1) {
      setSelectedTabs(activeIndex);
    }
  }, [location, tabsConfig]);

  const handleTabClick = useCallback(
    (index, label) => {
      setSelectedTabs(index); // Update the selected tab immediately

      // Handle navigation
      const path = getNavigationPath(label, lead, fornitori, vendite, subImposte, subAsset, subServizi, subProdotti, configuratore, sublistini, hrCandidato, hrEvento, hr, hrcalendario, subStabilimenti, subMezzi, subAttrezzature, leadAnagrafiche, anagraficheCandidato, colaboratoryAnagrafiche, fornitoriAnagrafiche, clientiAnagrafiche, organizza, organizzaCalender, subProgetti, subCantine, subTerreni, subStructureProdotti, subStructureStabiliment, ricette, subMezziLogistica, subStabilimentiLogistica,subSensori);
      navigate(path);

      // Invoke parent callback
      if (onTabChange) {
        onTabChange(`tab${index + 1}`);
      }
      if (onTabChange) {
        onTabChange(label); // Send label like "Oggi", "Ultima-Setiman"
      }
    },
    [lead, fornitori, navigate, onTabChange, vendite, subImposte, subAsset, subServizi, subProdotti, configuratore, sublistini, hrCandidato, hrEvento, hr, hrcalendario, subStabilimenti, subMezzi, subAttrezzature, leadAnagrafiche, anagraficheCandidato, colaboratoryAnagrafiche, fornitoriAnagrafiche, clientiAnagrafiche, organizza, organizzaCalender, subProgetti, subCantine, subTerreni, subStructureProdotti, subStructureStabiliment, ricette, subMezziLogistica, subStabilimentiLogistica,subSensori]
  );

  return (
    <Box className="tabBox">
      <CustomTabs
        className={customClassName}
        value={selectedTabs} // Ensure controlled state for Tabs
        onChange={(event, newValue) => setSelectedTabs(newValue)}
      >
        {getActiveConfig()?.map((tab, index) => {
          return (
            <CustomTab
              key={`${tab.label}-${index}`}
              label={tab.label==="ultima_settimana"? "Ultima Settimana" :tab.label==="ultimo_mese" ? "Ultimo mese": tab.label}
              onClick={() => handleTabClick(index, tab.label)}
              className={selectedTabs === index ? "Mui-selected" : ""}
            />
          );
        })}
      </CustomTabs>
    </Box>
  );
};

export default MenuTab;